<template>
  <div id="app" class="container">
    <br>
    <div class="row border-ePetro-title">
      <div class="col-md-6">
        <h1>{{this.$i18n.translate('FertilizerCalculator') | upperCase}}</h1>
      </div>
      <template v-if="showLanguageDropDown" class="form-control col-md-2 offset-md-4">
        <div class="col-md-2 offset-md-4">
          <h1 class="text-right">
            <icon icon="spinner" pulse />
          </h1>
        </div>
      </template>
     <template v-else>
      <transition name="fade" appear>
        <select
          v-model="selectedLanguage"
          class="form-control col-md-2 offset-md-4 input-ePetro"
          id="languageId"
          @change="languageChanged"
        >
          <option
            v-for="(option, index) in optionslanguageDropDown"
            :value="option.isoName"
            :key="index"
          >{{option.name}}</option>
        </select>
      </transition>
      </template>
    </div>
    <br>
    <div></div>
    <p>
      {{this.$i18n.translate('InformationsAboutCalucator')}}
    </p>
    <hr>
    <!-- VALIDATION MODAL POPUP -->
    <b-modal v-model="modalShowValidation" centered hide-footer >
      <h5 align="center">{{this.$i18n.translate('EnterAllParameters')}}</h5>
      <br>
      <div class="col-md-8 offset-md-2 text-center">
        <button
          type="button"
          class="btn btn-primary btn-lg"
          @click="modalShowValidation=!modalShowValidation"
        >{{this.$i18n.translate('OK')}}</button>
      </div>
      <br>
      <br>
    </b-modal>

    <div v-if="ShowInitialValue" class="text-center">
      <p>
        <em>{{this.$i18n.translate('Loading')}}</em>
      </p>
      <h1>
        <icon
          icon="spinner"
          pulse
        />
      </h1>
    </div>

    <div v-else>
      <form @submit.prevent="ValidateOnSubmit">
        <transition name="fade" appear >
          <app-default-parameters></app-default-parameters>
        </transition>
        <hr>
        <transition name="slide" appear >
          <app-additional-parameters></app-additional-parameters>
        </transition>

        <transition name="slideCalculate" appear >
          <div>
            <div class="form-row text-center">
              <br>
              <div class="col-md-12">
                <button
                  type="submit"
                  class="btn btn-calc-ePetro"
                >{{this.$i18n.translate('Calculate')}}</button>
              </div>
              <br>
              <br>
            </div>
            <br>
          </div>
        </transition>
      </form>
    </div>

    <template v-if="!loadIconResults">
      <h1 align="center"> 
        <icon icon="spinner" pulse />
      </h1>
    </template>

    <template v-else>
      <transition name="fade" v-if="showResults" appear>
        <app-results-container></app-results-container>
      </transition>
    </template>
  </div>
</template>

<script>

// Locally imported templates
import defaultParameters from './DefaultParameters';
import additionalParameters from './AdditionalParameters';
import resultContainer from './ResultsContainer';

import povrtna from "../assets/images/povrtna_kultura.png";
import ratarska from "../assets/images/ratarska_kultura.png";
import vocna from "../assets/images/vocna_kultura.png";

export default {
  data () {
    return {
      showLanguageDropDown: true,
      selectedLanguage: 'hr-HR',
      optionslanguageDropDown: [],
      loadIconResults: true,
      // show modal if there are validation errors
      modalShowValidation: false,
      dispatch: this.$store.dispatch,
      get: this.$store.getters,
      // Flag for showing results on submit
      showResults: false,
      cropTypes: [],

    };
  },
  // Mapping Vuex data to response submitButton data
  computed: {
    vuexCropID () {
      return this.get.cropID;
    },
    vuexCropStageID () {
      return this.get.cropStageId;
    },
    vuexYield () {
      return this.get.yield;
    },
    vuexYieldUnitId () {
      return this.get.yieldUnitId;
    },
    vuexSurface () {
      return this.get.surface;
    },
    vuexSurfaceUnitID () {
      return this.get.surfaceUnitId;
    },
    vuexK2O () {
      return this.get.k2O;
    },
    vuexP2O5 () {
      return this.get.p2O5;
    },
    vuexpH () {
      return this.get.ph;
    },
    vuexHumus () {
      return this.get.humus;
    },
    vuexSoilType () {
      return this.get.soilTypeId;
    },
    vuexSelectedFertilizersOnStages () {
      return this.get.selectedFertilizersOnStages;
    },
    ShowInitialValue () {
      return this.$store.getters.showInitialData;
    }
  },
  methods: {
    async ValidateOnSubmit () {
      await this.$validator.validateAll().then((result) => {
        // Check if result is true && cropId is not null
        if (result && this.get.cropID !== null) {
          this.onSubmit();
          return;
        }

        // dodati modal za prikaz poruke upozorenja
        this.modalShowValidation = true;

      });
    },
    onSubmit () {

      this.loadIconResults = false;
      const formData = {
        CropId: this.vuexCropID,
        CropStageID: this.vuexCropStageID,
        Yield: this.vuexYield,
        YieldUnitId: this.vuexYieldUnitId,
        Surface: this.vuexSurface,
        SurfaceUnitId: this.vuexSurfaceUnitID,
        K2O: this.vuexK2O,
        P2O5: this.vuexP2O5,
        pH: this.vuexpH,
        Humus: this.vuexHumus,
        SoilTypeID: this.vuexSoilType,
        selectedFertilizersOnStages: this.vuexSelectedFertilizersOnStages,
        Culture: this.selectedLanguage
      };

      console.log('---POSTED DATA ROOT---');
      console.log(formData);
      // Sending two POST requests
      // Preflighted requests first send an HTTP request OPTION to determine if the actual request is safe to send
      // https://stackoverflow.com/questions/48255545/axios-getting-two-requests-options-post
      this.$http.post('Calculator', formData)
        .then(res => {

          // Response data
          const responseData = res.data.data;
          console.log(`----- RESPONSE DATA ----`);
          console.log(responseData);

          // Show results on post
          this.showResults = true;

          // Nutrients response
          const nutrients = responseData.nutrients;

          // FertilizerRecommendations response
          const fertilizerRecommendations = responseData.fertilizerRecommendations;

          // console.log(fertilizerRecommendations);
          // Recommendations response
          const recommendations = responseData.recommendations;


          // Storing response data in Vuex
          this.$store.dispatch('UpdateNutrients', nutrients);
          this.$store.dispatch('UpdateRecommendations', recommendations);
          this.$store.dispatch('UpdateFertilizerRecommendations', fertilizerRecommendations);
          this.$store.dispatch('UpdateResponseData', responseData);

          this.loadIconResults = true;
          // this.$forceUpdate();
        })
        .catch(error => {
          console.log(error);
          this.errorSubmit = true;
          this.showResults = false;
          this.$store.dispatch('UpdateErrorSubmit', this.errorSubmit);
        });
    },
    languageChanged () {
      this.$i18n.set(this.selectedLanguage);

      if (this.selectedLanguage === 'en-US') {
        this.$validator.localize('en');
      }
      if (this.selectedLanguage === 'hr-HR') {
        this.$validator.localize('hr');
      }
      if (this.selectedLanguage === 'hu-HU') {
        this.$validator.localize('hu');
      }



      // fetch data on change language
      try {
        var cropTypesFinal = [];
        this.$http.get('cropType').then(response => {
          console.log(response);
          response.data.data.forEach(function (element) {
            var tmpType = element;
            switch (element.type) {
              case 1:
                tmpType.imageSrc = ratarska;
                break;
              case 2:
                tmpType.imageSrc = povrtna;
                break;
              case 3:
                tmpType.imageSrc = vocna;
                break;
            }
            cropTypesFinal.push(tmpType);
          });


        }).catch(error => {
          console.log(error)
        }).finally(() =>
          // change title of calculator on language change
          document.title = `${this.$i18n.translate('FertilizerCalculator')} - Petrokemija`,
          // populate dropdown value via vuex
          this.dispatch("UpdateCropTypes", cropTypesFinal),
          // remove loading icon via vuex
        );
      } catch (error) {
        console.log(error)
      }

    }
  },
  components: {
    // AppDefaultParameters automatically generates <app-default-parameters> tag
    AppDefaultParameters: defaultParameters,
    AppAdditionalParameters: additionalParameters,
    AppResultsContainer: resultContainer
  },
  filters: {
    upperCase: function (value) {
      return value.toUpperCase()
    }
  },
  created () {
    document.title = `${this.$i18n.translate('FertilizerCalculator')} - Petrokemija`
  },
  mounted () {
    var cropTypesFinal = [];

    // get language
    this.$http.get('Language')
      .then(response => {
        this.$nextTick(() => {
          this.optionslanguageDropDown = response.data.data;
        });
      })
      .catch(error => {
        console.log(error)
      })
      // on load show dropdown
      .finally(() => this.showLanguageDropDown = false);
  }
};

</script>

<style>
.bold-ePetro {
  font-weight: bold;
  color: #00ae4c;
  white-space: nowrap;
}

body {
  font-size: 16px;
  line-height: 21px;
  /* Text style for "Način prim" */
  font-weight: 400;
  /* Text style for "0800 64764" */
  font-family: "Arimo", sans-serif;
  font-weight: 700;
}

.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s;
}

.slide-enter-active {
  animation: slide-in 1s ease-in forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(50px);
  }
  to {
    transform: translateY(0);
  }
}

.slideCalculate-enter-active {
  animation: slide-in-calculate 2s ease-in forwards;
}

@keyframes slide-in-calculate {
  from {
    transform: translateY(100px);
  }

  to {
    transform: translateY(0);
  }
}
</style>
